module.exports = __webpack_public_path__ + "h5/img/ava1 (1).5b75b684.png";